/** RBAC capability labels — absorbs artifacts/web/src/lib/permission-group-labels.ts. */
export const permissions = {} as const;
